// import { useContext } from "react";
// import { GlobalContext } from "../../context/global";

import dashboard from '../../../assets/dashboard.png';

const DashboardAdmin = () => {
  return (
    <div>
        <img src={dashboard} alt='dashboard-statistic' style={{ width: '100%', height: '100%'}} />
     </div>
  );
};

export default DashboardAdmin;